<template>
    <div class="mx-auto container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-data-table v-if="load == true" :headers="headers" :items="standred_master_list" sort-by="standard"
                class="elevation-1 mytable" dense :search="search" :items-per-page="-1">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Standard Details</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details></v-text-field>
                        </v-col>
                        <span style="width: 20px;"></span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Standard</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-autocomplete v-model="editedItem.standard" label="Standard"
                                                        :items="standard_super_master_list" item-text="standard"
                                                        :disabled="editedIndex != -1" persistent-hint :hint="
                              editedIndex == -1
                                ? 'Select standard :: Nursary, LKG, UKG, I, II etc'
                                : 'noneditable'
                            " :filled="editedIndex == -1 ? false : true" :error="errorMsg.standard ? true : false"
                                                        :error-messages="
                              errorMsg.standard ? 'Required' : ''
                            " :rules="[(v) => !!v || 'required']"
                            @change="editedItem.unicode_standard = standard_super_master_list.find(s => s.standard === editedItem.standard).unicode_standard || ''"></v-autocomplete>
                                                </v-col>
                                            </v-row>
                                             <v-row>
                                                <v-col>
                                                    <v-text-field label="Standard In Unicode" v-model="editedItem.unicode_standard"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.display_name"
                                                        label="Display Name [optional]"
                                                        hint="For Example, I :: First Std. , II :: Second Std"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.std_in_words"
                                                        label="Standard in words"
                                                        hint="For Example, I:First, II:Second, III:Third..."></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.udise_no"
                                                        label="Udise No."></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-text-field v-model="editedItem.sort_order" type="number"
                                                        label="Sort Order"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-select dense v-model="editedItem.nextstandard"
                                                        :items="standred_master_list" item-text="standard"
                                                        item-value="id" label="Next Standard" persistent-hint
                                                        hint="Select Next Standard Ex. Nursary, LKG, UKG, I, II"
                                                        return-object single-line></v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-select dense v-model="editedItem.s_id" :items="section_list"
                                                        item-text="section_name" item-value="s_id" label="Section"
                                                        persistent-hint hint="Section Name..." single-line></v-select>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="6">
                                                    <p class="padding-bot"><b>Admission Start Date</b></p>
                                                    <input type="date" class="padding-bot"
                                                        v-model="editedItem.admission_start_date" />
                                                </v-col>
                                                <v-col cols="6">
                                                    <p class="padding-bot"><b>Admission End Date</b></p>
                                                    <input type="date" class="padding-bot"
                                                        v-model="editedItem.admission_end_date" />
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active?"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12">
                                                    <v-checkbox dense v-model="editedItem.new_admission_fee_applicable"
                                                        color="success"
                                                        label="Is New Admission Fee Applicable?"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:[`item.isstdate`]="{ item }">
                    <span v-if="item.admission_start_date">
                        {{ item.admission_start_date }}
                    </span>
                    <span v-else> -- </span>
                </template>

                <template v-slot:[`item.iseddate`]="{ item }">
                    <span v-if="item.admission_end_date">
                        {{ item.admission_end_date }}
                    </span>
                    <span v-else> -- </span>
                </template>

                <template v-slot:[`item.isactive`]="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success"
                            title="Active">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error"
                            title="Not Active">mdi-close-circle-outline</v-icon>
                    </span>
                </template>
                <template v-slot:[`item.new_admission_fee_applicable`]="{ item }">
                    <v-switch inset v-model="item.new_admission_fee_applicable"
                        :color="item.new_admission_fee_applicable ? 'success' : 'primary'"
                        @change="toggle_admission_fee(item)"></v-switch>
                </template>
                <template v-slot:[`item.feedback_allowed`]="{ item }">
                    <v-switch inset v-model="item.feedback_allowed"
                        :color="item.feedback_allowed ? 'success' : 'primary'"
                        @change="toggle_feedback_allowed(item)"></v-switch>
                </template>
                <template v-slot:[`item.is_active_for_admission`]="{ item }">
                    <v-switch inset v-model="item.is_active_for_admission"
                        :color="item.is_active_for_admission ? 'success' : 'primary'"
                        @change="toggle_is_active_for_admission(item)"></v-switch>
                </template>

                <template v-slot:[`item.action`]="{ item }">
                    <v-avatar style size="25" class="edit-avatar">
                        <v-icon class="edit-v-icon mr-2" @click="editItem(item)" title="edit" style>edit</v-icon>
                    </v-avatar>
                    <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
        </v-icon>-->
                </template>
                <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
      </template>-->
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            valid: false,
            errorMsg: {
                standard: false,
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            items: [],
            dialog: false,
            search: "",
            // extraBreadcrumbItems: [
            //     { text: "Standard Master", disabled: true, href: "" },

            // ],


            // breadcrumbClass: "breadcrumb-style2",
            load: false,
            headers: [
                {
                    text: "Standard",
                    value: "standard",
                },
                {
                    text: "Standard in Words",
                    value: "std_in_words",
                },
                {
                    text: "Standard in unicode",
                    value: "unicode_standard",
                },
                // {
                //   text: "Display Name",
                //   value: "display_name",
                // },
                // {
                //   text: "Next Standard",
                //   value: "nextstandard.standard",
                // },
                {
                    text: "Admission Start Date",
                    value: "admission_start_date_show",
                },
                {
                    text: "Admission End Date",
                    value: "admission_end_date_show",
                },
                {
                    text: "Udise No.",
                    value: "udise_no",
                },
                {
                    text: "Sort No.",
                    value: "sort_order",
                },
                {
                    text: "Section",
                    value: "section_name",
                },
                {
                    text: "New Admission Fee Applicable",
                    value: "new_admission_fee_applicable",
                },
                 {
                    text: "Feedback Allowed",
                    value: "feedback_allowed",
                },
                {
                    text: "Is Active For Admission?",
                    value: "is_active_for_admission",
                },
                {
                    text: "Active",
                    value: "isactive",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            standred_master_list: [],
            section_list: [],
            editedIndex: -1,
            editedItem: {
                nextstandard: "",
                standard: "",
                std_in_words: "",
                unicode_standard:"",
                display_name: "",
                isactive: false,
                new_admission_fee_applicable: false,
                udise_no: "",
                sort_order: "",
                section_id: "",
                admission_start_date: "",
                admission_end_date: "",
            },
            defaultItem: {
                nextstandard: "",
                standard: "",
                std_in_words: "",
                unicode_standard:"",
                display_name: "",
                isactive: false,
                new_admission_fee_applicable: false,
                sort_order: "",
                udise_no: "",
                section_id: "",
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Standard" : "Edit Standard";
            },
            stdList() {
                for (var i = 0; i < this.standred_master_list.length; i++) {
                    this.items[i] = {
                        standard: this.standred_master_list[i].standard,
                        display_name: this.standred_master_list[i].display_name,
                        isactive: this.standred_master_list[i].isactive,
                        new_admission_fee_applicable: this.standred_master_list[i].new_admission_fee_applicable,
                    };
                }
                return this.items;
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
        },

        created() {},
        mounted() {
            this.onload();
        },
        methods: {
            onload() {
                axios
                    .post("/AdmissionMaster/getStandard")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            this.standred_master_list = res.data.standred_master_list;
                            this.section_list = res.data.section_list;
                            this.standard_super_master_list = res.data.standard_super_master_list;
                            this.load = true;
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    });
            },
            initializeErrorMsgFalse() {
                this.errorMsg.standard = false;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            editItem(item) {
                this.editedIndex = this.standred_master_list.indexOf("insinde editItem assignment item");
                this.editedIndex = this.standred_master_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },

            deleteItem(item) {
                const index = this.standred_master_list.indexOf(item);
                confirm("Are you sure you want to delete this item?") && this.standred_master_list.splice(index, 1);
            },

            close() {
                this.dialog = false;
                this.initializeErrorMsgFalse();
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
            },

            save() {
                if (this.editedIndex > -1) {
                    if (this.isValidated()) {
                        axios
                            .post("/AdmissionMaster/editStandard", this.editedItem)
                            .then((res) => {
                                if (res.data.code == "SUCCESS") {
                                    this.onload();
                                    // Object.assign(
                                    //   this.standred_master_list[this.editedIndex],
                                    //   this.editedItem
                                    // );
                                    this.showSnackbar("#4caf50", "Standard Updated Successfully..."); // show snackbar on success
                                }
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });

                        this.close();
                    }
                } else {
                    if (this.isValidated()) {
                        axios
                            .post("/AdmissionMaster/saveStandard", this.editedItem)
                            .then((res) => {
                                if (res.data.status.code == "SUCCESS") {
                                    // this.standred_master_list.push(this.editedItem);
                                    this.showSnackbar("#4caf50", "Standard Added Successfully..."); // show snackbar on success
                                    this.onload();
                                } else if (res.data.status.code == "NA") {
                                    this.showSnackbar("#b71c1c", "Standard Already Present!!!"); // show snackbar on error
                                }
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });

                        this.close();
                    }
                }
            }, // end of save()

            isValidated() {
                if (this.editedItem.standard) {
                    return true;
                } else {
                    if (!this.editedItem.standard) {
                        this.errorMsg.standard = true;
                    }

                    return false;
                }
            }, // .....end of isValidated()
            toggle_admission_fee(item) {
                axios
                    .post("/AdmissionMaster/change_admission_fee_logic", item)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "New Admission Fee status changed...");
                        } else {
                            this.showSnackbar("#b71c1c", "Can't update Admission Fee status, please try again!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //overlay->loader
                    });
            },
             toggle_feedback_allowed(item) {
                const data = {
                    standard: item.id,
                    feedback_allowed: item.feedback_allowed,
                };
                axios
                    .post("/AdmissionMaster/toggle_feedback_allowed", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Updated Successfully...");
                        } else {
                            this.showSnackbar("#b71c1c", "Something Went Wrong...!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //overlay->loader
                    });
            },
            toggle_is_active_for_admission(item) {
                const data = {
                    standard: item.id,
                    is_active_for_admission: item.is_active_for_admission,
                };
                axios
                    .post("/AdmissionMaster/toggle_is_active_for_admission", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("#4caf50", "Updated Successfully...");
                        } else {
                            this.showSnackbar("#b71c1c", "Something Went Wrong...!");
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        //overlay->loader
                    });
            },
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>

